import { render, staticRenderFns } from "./DefaultDialog.vue?vue&type=template&id=3cf701a4&scoped=true&"
import script from "./DefaultDialog.vue?vue&type=script&lang=js&"
export * from "./DefaultDialog.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDialog.vue?vue&type=style&index=0&id=3cf701a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf701a4",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog});
